







































import { Component, Prop } from 'vue-property-decorator';
import Vue, { PropType } from 'vue';
import { ProductEntity } from '@/entities/product.entity';
import { UseService } from '@/services/service';
import OrderService from '@/services/order.service';
import ProductItemDetail from '@/components/ViewComponent/Exchange/ProductItemDetail.vue';
import NewIcon from '@/components/Helper/Icon/Svg/NewIcon.vue';
import moment from 'moment';
import CheeersCoinIcon from '@/components/Helper/Icon/Svg/CheeersCoinIcon.vue';

@Component<ProductItemPc>({
  components: { CheeersCoinIcon, NewIcon, ProductItemDetail },
})
export default class ProductItemPc extends Vue {
  @Prop({ type: Object as PropType<ProductEntity> })
  product: ProductEntity;

  @UseService(OrderService)
  service: OrderService;

  showDetail = false;

  get checkNewProduct(): boolean {
    const diffDay = moment(new Date()).diff(
      moment(this.product.createdAt),
      'days',
    );
    return diffDay <= 30;
  }

  async order() {
    try {
      await this.service.createOne({
        details: [{ productId: this.product.id, quantity: 1 }],
      });
    } catch (e) {
      await this.$cheeers.notify({
        text: e.response.data.message,
        type: 'error',
      });
    }
  }
}
